import React from 'react';

function SessionFooter() {
  return (
    <div className="session-footer">
      <ul>
        <li><a>Terms of Use</a></li>
        <li><a>Privacy & Cookies</a></li>
      </ul>
      <img src="images/microsoftLogo.svg" style={{width: '60px'}} />
    </div>
  );
}

export default SessionFooter;


// WEBPACK FOOTER //
// ./frontend/components/SessionFooter.jsx